import { z } from 'zod';
/**
 * Catálogos usados no atendimento (Etapa 3).
 *
 * Motivos de encerramento têm dois níveis: categoria (nível 1, obrigatória) → motivo (nível 2).
 * Motivos e respostas prontas valem para os setores marcados; **nenhum setor marcado = todos**.
 * Perfis podem restringir o que enxergam (ver `perfilFormSchema`).
 */
// ---- categorias (nível 1) ---------------------------------------------------
export const categoriaMotivoFormSchema = z.object({
    nome: z.string().trim().min(2, 'Informe o nome da categoria').max(60),
    ordem: z.coerce.number().int().min(0).max(999).default(0),
    ativo: z.boolean().default(true),
});
// ---- motivos (nível 2) ------------------------------------------------------
export const tagFormSchema = z.object({
    categoriaId: z.uuid('Escolha a categoria'),
    nome: z.string().trim().min(2, 'Informe o nome').max(60),
    ordem: z.coerce.number().int().min(0).max(999).default(0),
    /** Vazio = vale para todos os setores. */
    setorIds: z.array(z.uuid()).default([]),
    /**
     * Encerrar com este motivo não pede nota ao cliente. Para quando ele simplesmente
     * sumiu: avaliação de quem não está mais ali não mede nada, e a nota pendente ainda
     * trancaria o próximo atendimento dele.
     */
    dispensaAvaliacao: z.boolean().default(false),
    ativo: z.boolean().default(true),
});
// ---- respostas prontas ------------------------------------------------------
export const mensagemRapidaFormSchema = z.object({
    /** Digitado no chat como /atalho. Único no sistema, para não haver ambiguidade. */
    atalho: z
        .string()
        .trim()
        .toLowerCase()
        .min(1, 'Informe o atalho')
        .max(30)
        .regex(/^[a-z0-9-]+$/, 'Use apenas letras, números e hífen'),
    titulo: z.string().trim().min(2, 'Informe o título').max(80),
    conteudo: z.string().trim().min(2, 'Escreva a mensagem').max(2000),
    /** Vazio = vale para todos os setores. */
    setorIds: z.array(z.uuid()).default([]),
    ativo: z.boolean().default(true),
});
/**
 * O que o atendente preenche ao criar uma resposta dele.
 *
 * Sem setor e sem "ativo": resposta pessoal vale para quem a escreveu, em qualquer setor,
 * e desligar não faz sentido quando apagar é um clique.
 */
export const respostaPessoalFormSchema = z.object({
    atalho: z
        .string()
        .trim()
        .toLowerCase()
        .min(1, 'Informe o atalho')
        .max(30)
        .regex(/^[a-z0-9-]+$/, 'Use apenas letras, números e hífen'),
    titulo: z.string().trim().min(2, 'Informe o título').max(80),
    conteudo: z.string().trim().min(2, 'Escreva a resposta').max(2000),
});
/** Variáveis que o atendente pode usar no texto de uma resposta pronta. */
export const VARIAVEIS_MENSAGEM_RAPIDA = {
    '{{cliente}}': 'Primeiro nome do cliente',
    '{{atendente}}': 'Seu primeiro nome',
    '{{protocolo}}': 'Número do protocolo',
    '{{setor}}': 'Nome do setor',
};
/** Texto de apoio usado nas duas telas. */
export const AJUDA_SETORES = 'Nenhum setor marcado: vale para todos.';
export function rotuloSetores(setores) {
    return setores.length === 0 ? 'Todos os setores' : setores.map((s) => s.nome).join(', ');
}
//# sourceMappingURL=catalogos.js.map